import CaseInfoCard from "../CaseInfoCard";
import React, {useEffect, useState} from "react";
import {ICasesSectionData, IModel, ISection} from "../../model/B2CInfo";
import '../../MainScreen.css'
import './CasesItem.css'
import CaseButton from "./CaseButton";
import CarCard from "../../carcard/CarCard";
import {IOffer} from "../offer/Offer";
import OfferCard from "../offer/OfferCard";
import SectionHeader from "../../SectionHeader";
import {IFeature} from "../../features/Feature";
import FeatureCard from "../../features/FeatureCard";
import MobileSectionHeader from "../../MobileSectionHeader";
import MobileFeatureCard from "../../features/MobileFeatureCard";

export interface ICasesItemProps {
    section: ISection
    models: Map<string, IModel>
    offers: Map<string, IOffer>
    features: Map<string, IFeature>
    mobile: boolean
}

export default function CasesItem(props: ICasesItemProps) {
    const section = props.section;
    const cases = (section.data as Array<ICasesSectionData>);
    const [selectedCase, setSelectedCase] = useState<ICasesSectionData>(cases[0]);

    let casesElements = cases.map((item) => {
        return <CaseButton key={item.title} selected={selectedCase === item} title={item.title}
                           onClick={() => setSelectedCase(item)}
                           isMobile={props.mobile}/>
    });

    useEffect(() => {
        const cases = (section.data as Array<ICasesSectionData>);
        setSelectedCase(cases[0]);
    }, [props.section])

    if (props.mobile) {
        return <div className="Mobile_cases_container">
            <MobileSectionHeader section={props.section}/>
            <div className="Mobile_cases_wrap">{casesElements}</div>
            <div className="Mobile_cases_section">
                <span>Идеальные машины</span>
                <div className="Mobile_cases_section_wrap">
                    {
                        selectedCase.cars.map((item) => {
                            const model = props.models.get(item)!;
                            return <CarCard mobile={true} key={model.name} model={model} withShadow={true}/>;
                        })
                    }
                </div>
            </div>
            <div className="Mobile_cases_section">
                <span>Подходящие тарифы</span>
                <div className="Mobile_cases_section_wrap">
                    {
                        selectedCase.offers!.map((name) => {
                            let offer = props.offers.get(name)!;
                            return <OfferCard mobile={true} offer={offer}/>;
                        })
                    }
                </div>
            </div>
            <div className="Mobile_cases_section">
                <span>Пригодится в пути</span>
                <div className="Mobile_cases_section_wrap">
                    {
                        selectedCase.features!.map((name) => {
                            let feature = props.features.get(name)!;
                            return <div style={{width: "100%", height: `${(380 * window.innerWidth/375)}px`}}>
                                <MobileFeatureCard feature={feature} fullScreen={true}/>
                            </div>;
                        })
                    }
                </div>
            </div>
        </div>;
    } else {
        let casesInfoElements: JSX.Element[] = selectedCase.cars.map((item, index) => {
            console.log(props.models)
            console.log(typeof props.models)
            const model = props.models.get(item)!;
            return <CaseInfoCard
                key={model.name} title={index === 0 ? "Идеальные машины" : ""}
                child={<CarCard mobile={false} key={model.name} model={model} withShadow={true}/>}/>;
        });

        selectedCase.offers!.forEach((name, index) => {
            let offer = props.offers.get(name)!;
            casesInfoElements.push(
                <CaseInfoCard
                    key={offer.name}
                    title={index === 0 ? "Подходящие тарифы" : ""}
                    child={<OfferCard mobile={false} offer={offer}/>}/>
            );
        });

        selectedCase.features!.forEach((name, index) => {
            let feature = props.features.get(name)!;
            casesInfoElements.push(
                <CaseInfoCard
                    key={feature.title}
                    title={index === 0 ? "Что пригодится в пути" : ""}
                    child={<FeatureCard feature={feature}/>}/>
            );
        });

        return <div className="Cases_Container">
            <SectionHeader section={section}/>
            <div className="Cases_Wrap">{casesElements}</div>
            <div key={selectedCase.title} className="Cases_Info_Wrap">
                {casesInfoElements}
            </div>
        </div>;
    }
}